<template>
  <b-table
    responsive
    outlined
    :items="becasList"
    :fields="fieldsBecas"
    class="mb-0"
    show-empty
    empty-text="Aun no cuenta con becas activas."
    :busy="showLoading"
  >
    <template #cell(descripcion)="data">
      <span class="text-nowrap">
        {{ data.value }}
      </span>
    </template>

    <template #table-busy>
      <div class="text-center text-warning my-2">
        <b-spinner class="align-middle" />
        <strong> Cargando...</strong>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BTable, BSpinner } from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BecasAlumno } from './useKardex'

export default {
  components: {
    BTable,
    BSpinner,
  },
  props: {
    personaFk: {
      type: Number,
      default: () => null,
    },
  },
  setup(props) {
    const toast = useToast()
    const showLoading = ref(false)
    const becasList = ref(null)
    const fieldsBecas = ref([])

    fieldsBecas.value = [
      {
        key: 'periodo', label: 'Cuatrimestre',
      },
      'abrev',
      {
        key: 'descripcion', label: 'Tipo de Beca',
      },
    ]

    /**
     * * loadPagares
     * buscar los pagares de una solicitud
     */
    const BecasxPersona = () => {
      showLoading.value = true
      BecasAlumno(props.personaFk).then(response => {
        becasList.value = response.datos
        showLoading.value = false
      }, error => {
        showLoading.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención!',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(
      () => {
        BecasxPersona()
      },
    )

    return {
    // functions
      BecasxPersona,
      // values
      showLoading,
      becasList,
      fieldsBecas,
    }
  },
}
</script>
